const PaymentMethod = require('@/lib/PaymentMethods/PaymentMethod');
/**
 * @constructor
 *
 * @param {PaymentMethod} paymentMethod
 * @param {string|null} transactionRef
 * @param {bool} transactionRefIsValid
 */
const TransactionRefState = function (
    paymentMethod,
    transactionRef = null,
    transactionRefIsValid = false
) {
    if (!(paymentMethod instanceof PaymentMethod)) {
        throw new Error('paymentMethod must be an instance of PaymentMethod');
    }

    if (!(typeof transactionRef === 'string' || transactionRef === null)) {
        throw new Error('transactionRef must be string or null');
    }

    if (!(typeof transactionRefIsValid === 'boolean')) {
        throw new Error('transactionRefIsValid must be boolean');
    }

    this.paymentMethod = paymentMethod;
    this.transactionRef = transactionRef;
    this.transactionRefIsValid = transactionRefIsValid;
};

module.exports = TransactionRefState;
